"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOUVRE_WRITE_ROLES = exports.LOUVRE_READ_ROLES = exports.FORECASTS_WRITE_ROLES = exports.FORECASTS_READ_ROLES = void 0;
const Roles_1 = require("../enums/Roles");
exports.FORECASTS_READ_ROLES = [Roles_1.Roles.CallmartForecast, Roles_1.Roles.CallmartWTM];
exports.FORECASTS_WRITE_ROLES = [Roles_1.Roles.CallmartForecast];
/** CALL-809: Louvre checks the released Bidding volumes (WFM) that start as the strategic forecast
 *  (Forecast); WTM reads like on both of those pages. OSP never: the page shows every partner. */
exports.LOUVRE_READ_ROLES = [Roles_1.Roles.CallmartForecast, Roles_1.Roles.CallmartWFM, Roles_1.Roles.CallmartWTM];
/** Save a snapshot by hand and edit the variance table; either role is enough. */
exports.LOUVRE_WRITE_ROLES = [Roles_1.Roles.CallmartForecast, Roles_1.Roles.CallmartWFM];
